import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-5xl font-bold my-8 max-w-xl mx-auto" }, " Hey! This is a blockchain demos portal! ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, " Choose one of the options from the menu to see different blockchain applications in action! ", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}